import React, { useContext, useMemo, useEffect } from 'react';
import { useGetDocumentForUserQuery } from '../../services/documentsApi';
import TermsAndConditions from '../TermsAndConditions/TermsAndConditions';
import SignalREncorehiveContext from '../../context/signalREncorehive';

const DocumentsWrapper = ({ user, children }) => {
  const { signalREncorehive  } = useContext(SignalREncorehiveContext);

  const { data: documents = [], refetch } = useGetDocumentForUserQuery(user?.id, {
    skip: !user?.id
  });

  const sortedDocs = useMemo(() => {
    console.log('[documentsWrapper] sorting documents, length:', documents.length);
    if (!documents.length) return [];
    return [...documents].sort((a, b) => a.documentTypeID - b.documentTypeID);
  }, [documents]);

  const [showTerms, setShowTerms] = React.useState(false);

  React.useEffect(() => {
    console.log('[documentsWrapper] documents changed, length:', documents.length);
    if (documents.length > 0) {
      console.log('[documentsWrapper] showing terms modal');
      setShowTerms(true);
    }
  }, [documents]);


  //A: refetch documents endpoint when a new event related to documents is received (so the user can see the updated documents and sign them)
  useEffect(() => {
    if (!signalREncorehive) return;

    const handleDocumentCreated = (param) => {
      console.log('DocumentCreated event received:', param);
      refetch();
    };

    const handleDocumentEdited = (param) => {
      console.log('DocumentEdited event received:', param);
      refetch();
    };

    const handleDocumentTypeCreated = (param) => {
      console.log('DocumentTypeCreated event received:', param);
      refetch();
    };

    const handleDocumentTypeEdited = (param) => {
      console.log('DocumentTypeEdited event received:', param);
      refetch();
    };

    signalREncorehive.on('DocumentCreated', handleDocumentCreated);
    signalREncorehive.on('DocumentEdited', handleDocumentEdited);
    signalREncorehive.on('DocumentTypeCreated', handleDocumentTypeCreated);
    signalREncorehive.on('DocumentTypeEdited', handleDocumentTypeEdited);

    return () => {
      signalREncorehive.off('DocumentCreated', handleDocumentCreated);
      signalREncorehive.off('DocumentEdited', handleDocumentEdited);
      signalREncorehive.off('DocumentTypeCreated', handleDocumentCreated);
      signalREncorehive.off('DocumentTypeEdited', handleDocumentCreated);

    };
  }, [signalREncorehive, refetch]);

  const handleModalClose = () => {
    console.log('[documentsWrapper] closing terms modal');
    setShowTerms(false);
  };

  console.log('[documentsWrapper] rendering component, showTerms:', showTerms);
  return (
    <>
      {showTerms ? (
        <TermsAndConditions 
          open={showTerms} 
          handleClose={handleModalClose} 
          documents={sortedDocs} 
          user={user} 
        />
      ) : (
        children
      )}
    </>
  );
};

export default DocumentsWrapper;
